import moment from 'moment';
import { toaster } from 'evergreen-ui';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { requestInvoice } from '../../queries/subscription';
import { useNavigate } from 'react-router-dom';
import Account from '../../components/shikky/components/Account';

const PanelAccount = ({ settings, user }) => {
  const navigate = useNavigate();
  const token = useSelector(state => state.authentication.token);
  const requestInvoiceQuery = useMutation(requestInvoice, {
    useErrorBoundary: true,
    onSuccess: data => {
      if (!data || !data.ok) return toaster.danger('Something went wrong', { duration: 5 });
      navigate('/app/invoiceSentSuccess');
    },
  });
  const requestInvoiceCall = async invoiceEmail => {
    try {
      await requestInvoiceQuery.mutateAsync({ email: invoiceEmail, token });
    } catch (error) {
      console.log(error);
    }
  };

  const paymentDate = settings?.subscription?.paymentDate;
  const expiration = settings?.subscription?.expiration;

  let expirationText = 'No subscription';
  let shouldShowPaymentOptions = true;
  let subscriptionProgress = 0;

  if (expiration) {
    const expirationDate = moment(expiration).format('DD/MM/YYYY');
    const isExpired = moment(expiration).isSameOrBefore(moment(), 'day');
    const status = isExpired ? 'Expired' : 'Ending';
    expirationText = `Subscription ${status} ${expirationDate}`;
    if (moment().add(7, 'days').isBefore(moment(expiration))) shouldShowPaymentOptions = false;
    if (!isExpired) {
      const total = moment(paymentDate).diff(expiration, 'days');
      const passed = moment(paymentDate).diff(moment(), 'days');
      const missing = total - passed;
      subscriptionProgress = (missing / total) * 100;
      if (subscriptionProgress <= 1 || passed === 0) subscriptionProgress = 100;
    }
  }

  const callSupport = () => {
    window.open('https://wa.me/447537188768', '_blank').focus();
  };

  const logout = () => {
    localStorage.removeItem('gk_token');
    window.location.reload();
    return false;
  };

  const redirectToLink = () => {
    navigate('/app/accountRelinking');
  };

  return (
    <Account
      subscriptionProgress={subscriptionProgress}
      username={user.username}
      isLinked={!user.unauthorized}
      expiration={expirationText}
      shouldShowPaymentOptions={shouldShowPaymentOptions}
      price={settings?.paypalSubscriptionPrice}
      callSupport={callSupport}
      sendInvoice={requestInvoiceCall}
      androidURL="https://play.google.com/store/apps/details?id=com.grabkings.app"
      logout={logout}
      linkAccount={redirectToLink}
    />
  );
};

export default PanelAccount;
